import Vue from 'vue';
import Component from 'vue-class-component';

import BbHorizontalSlider from 'common/components/BbHorizontalSlider';
import BoxBlock from 'components/NewBoxBlock';
import SpinnerLoading from 'common/components/SpinnerLoading';
import OrderDropdown from 'components/OrderDropdown/OrderDropdown.vue';

import PaginatedBoxes from 'assets/graphql/queries/PaginatedBoxes.graphql';

@Component({
  components: {
    BbHorizontalSlider,
    BoxBlock,
    SpinnerLoading,
    OrderDropdown,
  },
  props: {
    campaign: {
      type: Object,
      description: 'Campaign products and information',
    },
  },
  apollo: {
    paginated_boxes: {
      query: PaginatedBoxes,
      fetchPolicy: 'network-only',
      variables() {
        return {
          page_number: 1,
          filters: JSON.stringify({
            campaign_slug: this.$route.params.campaignSlug,
          }),
          view: 'campaign',
          order_by: this.sortOption,
        };
      },
      update(data) {
        const { results, page_info } = data.paginated_boxes;
        this.boxes =
          page_info.number === 1 ? results : this.boxes.concat(results);
        this.hasNextPage = page_info.has_next;
        this.firstLoad = false;
        return data;
      },
    },
  },
})
export default class CustomCampaignBoxesComponent extends Vue {
  boxes = [];
  activePage = 1;
  hasNextPage = null;
  firstLoad = true;
  orderOptions = [
    { title: 'más nuevas', value: 'newer' },
    { title: 'menor precio', value: 'lower_price' },
    { title: 'mayor precio', value: 'higher_price' },
    this.campaign.show_percentage
      ? { title: 'mayor descuento', value: 'discounted_percentage' }
      : false,
  ];
  sortOption = '';

  async fetchMoreBoxes() {
    await this.$apollo.queries.paginated_boxes.fetchMore({
      variables: {
        page_number: this.activePage + 1,
        view: 'campaign',
        filters: JSON.stringify({
          campaign_slug: this.$route.params.campaignSlug,
        }),
        order_by: this.sortOption,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const { results, page_info } = fetchMoreResult.paginated_boxes;
        this.boxes =
          page_info.number === 1 ? results : this.boxes.concat(results);
        this.activePage += 1;
        this.hasNextPage = page_info.has_next;
      },
    });
  }

  async updateFilter({ sort }) {
    this.sortOption = sort;
    await this.fetchMoreBoxes();
  }
}
